import { client } from "api/client";
import * as actions from "modules/common/store/actions";
import { GetLanguageCode } from "utilities/localize";
import * as utility from "utilities/utils";
import { CONSTANTS } from "utilities/constants";
import { ENDPOINTS } from "utilities/endPoints";

export default function getDeviationDeparture(departures) {
    let givenDestinations = departures.filter(function (param) { return param.length > 0; });

    return async (dispatch) => {

        let productTypes = [ CONSTANTS.PACKAGE, CONSTANTS.CRUISE ];
        let responses = [];
        let gateways = [];
        const lang = GetLanguageCode();
        
        try
        {
            // get response for all product types
            await Promise.all(productTypes.map(async (productType) => {
                await Promise.all(givenDestinations.map(async (destination) => {
                    let url = `${process.env.REACT_APP_SEARCH_API}${ENDPOINTS.SEARCH_API.DEPARTURE}/group?lang=${lang}&type=${productType}&alias=${process.env.REACT_APP_SEARCH_ALIAS}&dest=${destination}`;
                    const response = await client.get(url);
                    responses.push(response);
                }));
            }));
        }
        catch(error) {
            return dispatch({
                type: actions.GET_DEVIATION_DEPARTURE_CITIES_FAIL,
                payload: utility.getErrorResponse(error)
            });
        }

        // iterate each response and  populate the destination array
        for(const response of responses) {
            if(response.Regions) {
                for(const region of response.Regions) {
                    if(region.GatewayGroups) {
                        for(const gatewayGroup of region.GatewayGroups) {
                            if(gatewayGroup.Gateways) {
                                for(const gateway of gatewayGroup.Gateways) {
                                    const city = { code: gateway.Code, name: gateway.Name };
                                    const exist = gateways.find(s => s.provinceCode?.toLowerCase() === gatewayGroup.Code?.toLowerCase());
                                    if (exist)
                                    {
                                        var existingCity = gateways.find(a => (a.cities.find(q => q.code?.toLowerCase() ===  gateway.Code?.toLowerCase())) !== undefined);
                                        if (!existingCity)
                                            exist.cities.push(city);
                                    }
                                    else
                                    {
                                        gateways.push({
                                            countryCode: gateway.CountryCode,
                                            countryName: gateway.CountryName,
                                            provinceCode: gatewayGroup.Code,
                                            provinceName: gatewayGroup.Name,
                                            cities: [ city ]
                                        });
                                        
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return dispatch({
            type: actions.GET_DEVIATION_DEPARTURE_CITIES_SUCCESS,
            payload: utility.getResponse(gateways)
        });
    };
}


export function resetDeviationDeparture() {
    return async (dispatch) => {
        return dispatch({
            type: actions.DEVIATION_DEPARTURE_CITIES_RESET
        });

    };
}